import '../global.css';

const PlayListSection = () => (
    <section className='playlist-section'>
    </section>
);

export default PlayListSection;